import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '../../styles';
import { Column } from '../layout/flex';
import { Counter } from './counter';
import { Editor } from './editor';
import { PlaceholderText } from './placeholder_text';
export function InCallEditor(props) {
    return (_jsxs(Wrapper, { children: [_jsx(PlaceholderText, { left: "1.0rem", marginTop: "0.5rem" }), _jsx(EditorWrapper, { "data-testid": "notes-editor-wrapper", children: _jsx(Editor, { ...props }) }), _jsx(Counter, {})] }));
}
const EditorWrapper = styled.div({
    height: '15.8125rem',
    overflowY: 'auto',
    margin: '.5rem',
});
const Wrapper = styled(Column)(({ theme }) => ({
    background: theme.colors.white,
    padding: '.5rem 0 .5rem .5rem',
    borderBottomLeftRadius: '.5rem',
    borderBottomRightRadius: '.5rem',
    position: 'relative',
    justifyContent: 'space-between',
    overflowWrap: 'break-word',
}));
//# sourceMappingURL=in_call_editor.js.map